import React from "react";
import { object, array, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import GlideSlider from "../../molecules/glide-slider";
import StoryHeader from "../story-header";
import AuthorDetails from "../../molecules/author-details";
import MetypeCommentWrapper from "../../metype-comments";
import StoryTags from "../story-tag";
import SideBarCollectionWithAd from "../../molecules/sidebar-collection-ad";
import StoryCard from "../story-card";

import "./photo.m.css";

export class PhotoStoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderMetype: false,
      carouselIndex: 1
    };
    this.galleryItems = [];
  }

  componentDidMount() {
    this.galleryItems = this.getImagesFromCards();
    this.setState({
      renderMetype: true,
      totalItems: this.galleryItems.length
    });
  }

  getImagesFromCards() {
    return this.props.story.cards.reduce((accumulator, currentValue) => {
      const storyElements = currentValue["story-elements"];
      const imageElements = storyElements.filter(element => element.type === "image");
      accumulator = accumulator.concat(imageElements);
      return accumulator;
    }, []);
  }

  render() {
    const { story, collections, metypeConfig, isBreakingNews } = this.props;
    const { totalItems, renderMetype } = this.state;
    const authorDetails = {
      name: get(story, ["authors", 0, "name"], story["author-name"]),
      id: story["author-id"],
      "twitter-handle": get(story, ["authors", 0, "twitter-handle"]),
      "avatar-url": get(story, ["authors", 0, "avatar-url"]),
      slug: get(story, ["authors", 0, "slug"]),
      "avatar-s3-key": get(story, ["authors", 0, "avatar-s3-key"])
    };

    return (
      <div styleName={`photo-story ${isBreakingNews ? "" : "heading-top-margin"}`}>
        <div>
          {/* Photo Slider */}
          <div styleName="photo-slider">
            {this.galleryItems.length > 0 && (
              <GlideSlider story={story} totalItems={totalItems} getImagesFromCards={this.galleryItems} />
            )}
          </div>

          {/* Title and Sub Title */}
          <StoryHeader story={story} subTitleClass="heading-space" />

          {/* Content */}
          <div styleName="story-body">
            <SocialShare
              template={StickySocialShareTemplate}
              title={story.headline}
              url={story.slug}
              color="#000"
              sticky
            />
            <div styleName="story-content">
              <div styleName="author-wrapper">
                <AuthorDetails author={authorDetails} updatedOn={story["last-published-at"]} />
              </div>
              {story.cards.map(card => (
                <StoryCard key={card.id} card={card} story={story} />
              ))}
              <StoryTags tags={story.tags} />
            </div>
          </div>
          {renderMetype && <MetypeCommentWrapper metypeConfig={metypeConfig} story={story} />}
        </div>

        {/* Side Bar collections with Advertisement */}
        <SideBarCollectionWithAd collections={collections} story={story} />
      </div>
    );
  }
}

function PhotoStoryView({ story, metypeConfig, collections, breakingNews, breakingNewsLoaded }) {
  const isBreakingNews = !!(breakingNewsLoaded && breakingNews.length !== 0);

  return (
    <div className="story-grid">
      <PhotoStoryTemplate
        story={story}
        metypeConfig={metypeConfig}
        collections={collections}
        isBreakingNews={isBreakingNews}
      />
    </div>
  );
}

function mapStateToProps(state) {
  const { breakingNews, breakingNewsLoaded } = state;

  return {
    breakingNews,
    breakingNewsLoaded
  };
}

PhotoStoryTemplate.propTypes = {
  story: object,
  metypeConfig: object,
  collections: object,
  isBreakingNews: bool
};

PhotoStoryView.propTypes = {
  story: object,
  collections: object,
  metypeConfig: object,
  breakingNews: array,
  breakingNewsLoaded: bool
};

const PhotoStory = connect(mapStateToProps)(PhotoStoryView);

export default PhotoStory;
